var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import * as _ from 'lodash';
//  通用函数
function getEnumDesc(valueMap, val) {
    return _.keys(valueMap)
        .filter(function (key) {
        return key > 0 && (key & val) > 0;
    })
        .map(function (key) { return valueMap[key]; })
        .join(',');
}
// 登录类型
export var LoginType;
(function (LoginType) {
    LoginType[LoginType["Phone"] = 0] = "Phone";
    LoginType[LoginType["Email"] = 1] = "Email";
})(LoginType || (LoginType = {}));
// 角色
export var Role;
(function (Role) {
    Role[Role["None"] = -1] = "None";
    Role[Role["YeWuYuan"] = 0] = "YeWuYuan";
    Role[Role["QiYe"] = 1] = "QiYe";
    Role[Role["Server"] = 2] = "Server";
    Role[Role["S2S"] = 3] = "S2S";
    Role[Role["KeFu"] = 4] = "KeFu";
})(Role || (Role = {}));
export var RoleValueMap = (_a = {},
    _a[Role.None] = '全部',
    _a[Role.YeWuYuan] = '业务员',
    _a[Role.KeFu] = '客服',
    _a[Role.QiYe] = '企业管理员',
    _a[Role.Server] = 'Admin',
    _a[Role.S2S] = 'S2S',
    _a);
export function getRoleDesc(role) {
    return RoleValueMap[role];
}
// 实体状态
export var ActiveState;
(function (ActiveState) {
    ActiveState[ActiveState["None"] = -1] = "None";
    ActiveState[ActiveState["Normal"] = 0] = "Normal";
    ActiveState[ActiveState["Freeze"] = 1] = "Freeze";
    ActiveState[ActiveState["Off"] = 2] = "Off";
})(ActiveState || (ActiveState = {}));
export var ActiveStateValueMap = (_b = {},
    _b[ActiveState.None] = '全部',
    _b[ActiveState.Normal] = '正常',
    _b[ActiveState.Freeze] = '冻结',
    _b[ActiveState.Off] = '关闭',
    _b);
export function getActiveStateDesc(activeState) {
    return ActiveStateValueMap[activeState];
}
// 商品类型子类型
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["None"] = -1] = "None";
    ProductType[ProductType["HY"] = 1] = "HY";
    ProductType[ProductType["LY"] = 2] = "LY";
})(ProductType || (ProductType = {}));
export var ProductTypeValueMap = (_c = {},
    _c[ProductType.None] = '全部',
    _c[ProductType.HY] = '航意险',
    _c[ProductType.LY] = '旅意险',
    _c);
export function getProductTypeDesc(productType) {
    return getEnumDesc(ProductTypeValueMap, productType);
}
export var ProductSubType;
(function (ProductSubType) {
    ProductSubType[ProductSubType["None"] = -1] = "None";
    ProductSubType[ProductSubType["CJY"] = 2] = "CJY";
    ProductSubType[ProductSubType["GNY"] = 4] = "GNY";
    ProductSubType[ProductSubType["ZJY"] = 8] = "ZJY";
    ProductSubType[ProductSubType["JWYX"] = 16] = "JWYX";
    ProductSubType[ProductSubType["SGQZ"] = 32] = "SGQZ";
    ProductSubType[ProductSubType["YDHW"] = 64] = "YDHW";
})(ProductSubType || (ProductSubType = {}));
export var ProductSubTypeValueMap = (_d = {},
    _d[ProductSubType.None] = '全部',
    _d[ProductSubType.CJY] = '出境游',
    _d[ProductSubType.ZJY] = '自驾游',
    _d[ProductSubType.GNY] = '国内游',
    _d[ProductSubType.JWYX] = '境外游学',
    _d[ProductSubType.SGQZ] = '申根签证',
    _d[ProductSubType.YDHW] = '运动户外',
    _d);
export function getProductSubTypeDesc(productSubType) {
    return getEnumDesc(ProductSubTypeValueMap, productSubType);
}
// 订单状态
export var PaymentState;
(function (PaymentState) {
    PaymentState[PaymentState["None"] = -1] = "None";
    PaymentState[PaymentState["Created"] = 0] = "Created";
    PaymentState[PaymentState["ToBePaid"] = 1] = "ToBePaid";
    PaymentState[PaymentState["Paid"] = 2] = "Paid";
    PaymentState[PaymentState["Pending"] = 3] = "Pending";
    PaymentState[PaymentState["Finish"] = 4] = "Finish";
    PaymentState[PaymentState["RefundPending"] = 5] = "RefundPending";
    PaymentState[PaymentState["Refund"] = 6] = "Refund";
    PaymentState[PaymentState["Expired"] = 7] = "Expired";
    PaymentState[PaymentState["SurrenderedAndWaitForRefund"] = 8] = "SurrenderedAndWaitForRefund";
    PaymentState[PaymentState["RefundedAndWaitForSurrender"] = 9] = "RefundedAndWaitForSurrender";
})(PaymentState || (PaymentState = {}));
export var PaymentStateValueMap = (_e = {},
    _e[PaymentState.None] = '全部',
    _e[PaymentState.Created] = '创建订单',
    _e[PaymentState.ToBePaid] = '正在付款',
    _e[PaymentState.Paid] = '已付款',
    _e[PaymentState.Pending] = '准备出保',
    _e[PaymentState.Finish] = '已投保',
    _e[PaymentState.RefundPending] = '正在退保',
    _e[PaymentState.Refund] = '已退款',
    _e[PaymentState.Expired] = '已过期',
    _e[PaymentState.SurrenderedAndWaitForRefund] = '已退保等待退款',
    _e[PaymentState.RefundedAndWaitForSurrender] = '已退款等待退保',
    _e);
export function getPaymentStateDesc(state) {
    return PaymentStateValueMap[state];
}
// 支付类型
export var PayType;
(function (PayType) {
    PayType[PayType["TongLian"] = 1] = "TongLian";
    PayType[PayType["Cash"] = 2] = "Cash";
    PayType[PayType["ZhiShou"] = 4] = "ZhiShou";
    PayType[PayType["TongLianXCXZS"] = 8] = "TongLianXCXZS";
    PayType[PayType["YueJie"] = 16] = "YueJie";
})(PayType || (PayType = {}));
export var PayTypeValueMap = (_f = {},
    _f[PayType.TongLian] = "线上支付",
    _f[PayType.Cash] = "现金支付",
    _f[PayType.ZhiShou] = "保司直收",
    _f[PayType.TongLianXCXZS] = "微信小程序收款",
    _f[PayType.YueJie] = "月结",
    _f);
export function getPayTypeDesc(payType) {
    return getEnumDesc(PayTypeValueMap, payType);
}
// 发票类型
export var InvoiceType = {
    Personal: "P",
    QiYe: "B"
};
// 销售平台
export var SaleChannel;
(function (SaleChannel) {
    SaleChannel[SaleChannel["None"] = -1] = "None";
    SaleChannel[SaleChannel["App"] = 1] = "App";
    SaleChannel[SaleChannel["H5"] = 2] = "H5";
})(SaleChannel || (SaleChannel = {}));
export var SaleChannelValueMap = (_g = {},
    _g[SaleChannel.None] = '全部',
    _g[SaleChannel.App] = 'App',
    _g[SaleChannel.H5] = 'H5',
    _g);
export function getSaleChannelDesc(channel) {
    return getEnumDesc(SaleChannelValueMap, channel);
}
// 任务状态
export var TaskState;
(function (TaskState) {
    TaskState[TaskState["Doing"] = 0] = "Doing";
    TaskState[TaskState["Done"] = 1] = "Done";
})(TaskState || (TaskState = {}));
// 销售主体
export var SaleEntityType = {
    None: '',
    YG: 'yg',
    DFDD: 'dfdd',
    HY: 'hy'
};
export var SaleEntityValueMap = (_h = {},
    _h[SaleEntityType.None] = '全部',
    _h[SaleEntityType.YG] = '阳光',
    _h[SaleEntityType.DFDD] = '东方大地',
    _h[SaleEntityType.HY] = '华育',
    _h);
export function getSaleEntity(id) {
    if (!id)
        return {};
    /*
        todo：慢慢的拆开，不能通过ID去拆，需要明确的值
        1. 支付 ✅
        2. 保险公司 ✅
        3. 产品
     */
    if (_.has(SaleEntityValueMap, id))
        return {
            name: SaleEntityValueMap[id],
            saleEntity: id,
            realId: ""
        };
    var info = id.split('-');
    var saleEntity = info.length > 1 ? info[1] : 'yg';
    return {
        realId: info[0],
        saleEntity: saleEntity,
        name: SaleEntityValueMap[saleEntity],
    };
}
// 保险公司
export var BaoSiId = {
    TaiKang: 'taikang',
    TaiPing: 'taiping',
    DongWu: 'dongwu',
    HuaTai: 'huatai',
};
export var BaoSiIdValueMap = (_j = {},
    _j[BaoSiId.TaiKang] = '泰康',
    _j[BaoSiId.TaiPing] = '太平',
    _j[BaoSiId.DongWu] = '东吴',
    _j[BaoSiId.HuaTai] = '华泰',
    _j);
export function getBaoSiName(id) {
    return BaoSiIdValueMap[id];
}
// 默认的时区
export var defaultTimeZone = 'Asia/Shanghai';
// 以下几个类型，只用于记录！！
// 证件类型
export var CertType = {
    SFZ: "01",
    HZ: "02",
    JSZ: "04",
    GATBZ: "05",
    ZGHZ: "07",
    WGRSFZ: "08",
    DATJZZ: "09",
    CSYXZM: "11",
    WGHZ: "12",
    CSRQ: "13",
    GATXZ: "14",
    TWTXZ: "15",
    HKB: "22",
    TYSHXYDM: "97",
    QT: "99", // 其他
};
// 性别
export var SexType = {
    Man: 1,
    Women: 2
};
// 关系
export var Relation = {
    GeRen: "01",
    ZiNv: "40",
    PeiOu: "10",
    FuMu: "50",
    QiTa: "99", // 其他
};
// 国家代码
export var countryCode = {
    "AFG": "阿富汗",
    "ALB": "阿尔巴尼亚",
    "DZA": "阿尔及利亚",
    "ASM": "美属萨摩亚",
    "AND": "安道尔",
    "AGO": "安哥拉",
    "AIA": "安圭拉",
    "ATA": "南极洲",
    "ATG": "安提瓜和巴布达",
    "ARG": "阿根廷",
    "ARM": "亚美尼亚",
    "ABW": "阿鲁巴",
    "AUS": "澳大利亚",
    "AUT": "奥地利",
    "AZE": "阿塞拜疆",
    "BHS": "巴哈马",
    "BHR": "巴林",
    "BGD": "孟加拉国",
    "BRB": "巴巴多斯",
    "BLR": "白俄罗斯",
    "BEL": "比利时",
    "BLZ": "伯利兹",
    "BEN": "贝宁",
    "BMU": "百慕大",
    "BTN": "不丹",
    "BOL": "玻利维亚",
    "BIH": "波黑",
    "BWA": "博茨瓦纳",
    "BVT": "布维岛",
    "BRA": "巴西",
    "IOT": "英属印度洋领土",
    "BRN": "文莱",
    "BGR": "保加利亚",
    "BFA": "布基纳法索",
    "BDI": "布隆迪",
    "KHM": "柬埔寨",
    "CMR": "喀麦隆",
    "CAN": "加拿大",
    "CPV": "佛得角",
    "CYM": "开曼群岛",
    "CAF": "中非",
    "TCD": "乍得",
    "CHL": "智利",
    "CHN": "中国",
    "HKG": "香港",
    "MAC": "澳门",
    "TWN": "台湾",
    "CSR": "圣诞岛",
    "CCK": "科科斯(基林)群岛",
    "COL": "哥伦比亚",
    "COM": "科摩罗",
    "COG": "刚果（布）",
    "COD": "刚果（金）",
    "COK": "库克群岛",
    "CRI": "哥斯达黎加",
    "CIV": "科特迪瓦",
    "HRV": "克罗地亚",
    "CUB": "古巴",
    "CYP": "塞浦路斯",
    "CZE": "捷克",
    "DNK": "丹麦",
    "DJI": "吉布提",
    "DMA": "多米尼克",
    "DOM": "多米尼加共和国",
    "TMP": "东帝汶",
    "ECU": "厄瓜多尔",
    "EGY": "埃及",
    "SLV": "萨尔瓦多",
    "GNQ": "赤道几内亚",
    "ERI": "厄立特里亚",
    "EST": "爱沙尼亚",
    "ETH": "埃塞俄比亚",
    "FLK": "福克兰群岛(马尔维纳斯)",
    "FRO": "法罗群岛",
    "FJI": "斐济",
    "FIN": "芬兰",
    "FRA": "法国",
    "GUF": "法属圭亚那",
    "PYF": "法属波利尼西亚",
    "ATF": "法属南部领土",
    "GAB": "加蓬",
    "GMB": "冈比亚Gambia",
    "GEO": "格鲁吉亚",
    "DEU": "德国",
    "GHA": "加纳",
    "GIB": "直布罗陀",
    "GRC": "希腊",
    "GRL": "格陵兰",
    "GRD": "格林纳达",
    "GLP": "瓜德罗普",
    "GUM": "关岛",
    "GTM": "危地马拉",
    "GIN": "几内亚",
    "GNB": "几内亚比绍",
    "GUY": "圭亚那",
    "HTI": "海地",
    "HMD": "赫德岛和麦克唐纳岛",
    "HND": "洪都拉斯",
    "HUN": "匈牙利",
    "ISL": "冰岛",
    "IND": "印度",
    "IDN": "印度尼西亚",
    "IRN": "伊朗",
    "IRQ": "伊拉克",
    "IRL": "爱尔兰",
    "ISR": "以色列",
    "ITA": "意大利",
    "JAM": "牙买加",
    "JPN": "日本",
    "JOR": "约旦",
    "KAZ": "哈萨克斯坦",
    "KEN": "肯尼亚",
    "KIR": "基里巴斯",
    "PRK": "朝鲜",
    "KOR": "韩国",
    "KWT": "科威特",
    "KGZ": "吉尔吉斯斯坦",
    "LAO": "老挝",
    "LVA": "拉脱维亚",
    "LBN": "黎巴嫩",
    "LSO": "莱索托",
    "LBR": "利比里亚",
    "LBY": "利比亚",
    "LIE": "列支敦士登",
    "LTU": "立陶宛",
    "LUX": "卢森堡",
    "MKD": "前南马其顿",
    "MDG": "马达加斯加",
    "MWI": "马拉维",
    "MYS": "马来西亚",
    "MDV": "马尔代夫",
    "MLI": "马里",
    "MLT": "马耳他",
    "MHL": "马绍尔群岛",
    "MTQ": "马提尼克",
    "MRT": "毛里塔尼亚",
    "MUS": "毛里求斯",
    "MYT": "马约特",
    "MEX": "墨西哥",
    "FSM": "密克罗尼西亚联邦",
    "MDA": "摩尔多瓦",
    "MCO": "摩纳哥",
    "MNG": "蒙古",
    "MSR": "蒙特塞拉特",
    "MAR": "摩洛哥",
    "MOZ": "莫桑比克",
    "MMR": "缅甸",
    "NAM": "纳米比亚",
    "NRU": "瑙鲁",
    "NPL": "尼泊尔",
    "NLD": "荷兰",
    "ANT": "荷属安的列斯",
    "NCL": "新喀里多尼亚",
    "NZL": "新西兰",
    "NIC": "尼加拉瓜",
    "NER": "尼日尔",
    "NGA": "尼日利亚",
    "NIU": "纽埃",
    "NFK": "诺福克岛",
    "MNP": "北马里亚纳",
    "NOR": "挪威",
    "OMN": "阿曼",
    "PAK": "巴基斯坦",
    "PLW": "帕劳",
    "PST": "巴勒斯坦",
    "PAN": "巴拿马",
    "PNG": "巴布亚新几内亚",
    "PRY": "巴拉圭",
    "PER": "秘鲁",
    "PHL": "菲律宾",
    "PCN": "皮特凯恩群岛",
    "POL": "波兰",
    "PRT": "葡萄牙",
    "PRI": "波多黎各",
    "QAT": "卡塔尔",
    "REU": "留尼汪",
    "ROM": "罗马尼亚",
    "RUS": "俄罗斯联邦",
    "RWA": "卢旺达",
    "S00": "申根国家",
    "SHN": "圣赫勒拿",
    "KNA": "圣基茨和尼维斯",
    "LCA": "圣卢西亚",
    "SPM": "圣皮埃尔和密克隆",
    "VCT": "圣文森特和格林纳丁斯",
    "WSM": "萨摩亚",
    "SMR": "圣马力诺",
    "STp": "圣多美和普林西比",
    "SAU": "沙特阿拉伯",
    "SEN": "塞内加尔",
    "SYC": "塞舌尔",
    "SLE": "塞拉利昂",
    "SGP": "新加坡",
    "SVK": "斯洛伐克",
    "SVN": "斯洛文尼亚",
    "SLB": "所罗门群岛",
    "SOM": "索马里",
    "ZAF": "南非",
    "SGS": "南乔治亚岛和南桑德韦奇岛",
    "ESP": "西班牙",
    "LKA": "斯里兰卡",
    "SDN": "苏丹",
    "SUR": "苏里南",
    "SJM": "斯瓦尔巴群岛",
    "SWZ": "斯威士兰",
    "SWE": "瑞典",
    "CHE": "瑞士",
    "SYR": "叙利亚",
    "TJK": "塔吉克斯坦",
    "TZA": "坦桑尼亚",
    "THA": "泰国",
    "TGO": "多哥",
    "TKL": "托克劳",
    "TON": "汤加",
    "TTO": "特立尼达和多巴哥",
    "TUN": "突尼斯",
    "TUR": "土耳其",
    "TKM": "土库曼斯坦",
    "TCA": "特克斯科斯群岛",
    "TUV": "图瓦卢",
    "UGA": "乌干达",
    "UKR": "乌克兰",
    "ARE": "阿联酋",
    "GBR": "英国",
    "USA": "美国",
    "UMI": "美国本土外小岛屿",
    "URY": "乌拉圭",
    "UZB": "乌兹别克斯坦",
    "VUT": "瓦努阿图",
    "VAT": "梵蒂冈",
    "VEN": "委内瑞拉",
    "VNM": "越南",
    "VGB": "英属维尔京群岛",
    "VIR": "美属维尔京群岛",
    "WLF": "瓦利斯和富图纳",
    "ESH": "西撒哈拉",
    "YEM": "也门",
    "YUG": "南斯拉夫",
    "ZMB": "赞比亚",
    "ZWE": "津巴布韦",
    "SSD": "南苏丹",
    "MAF": "法属圣马丁",
    "SXM": "荷属圣马丁",
    "SRB": "塞尔维亚",
    "MNE": "黑山",
    "GMR": "盖比群岛",
    "TMU": "土阿莫土群岛",
    "SOC": "社会群岛",
    "MLN": "梅利利亚",
    "SAI": "塞卜泰(休达)",
    "CNY": "加那利群岛",
    "SAB": "萨巴",
    "BON": "博内尔",
    "CUW": "库腊索岛",
    "SCG": "塞尔维亚和黑山",
    "NME": "诺曼底群岛",
    "IMN": "马恩岛",
    "XXX": "其他"
};
export function getCountryDesc(code) {
    return countryCode[code] || countryCode["XXX"];
}
// 保单生效规则
export var EffectRules;
(function (EffectRules) {
    EffectRules[EffectRules["Now"] = 0] = "Now";
    EffectRules[EffectRules["Hour"] = 1] = "Hour";
    EffectRules[EffectRules["Tomorrow"] = 2] = "Tomorrow";
    EffectRules[EffectRules["NowAdd1Hour"] = 3] = "NowAdd1Hour";
    EffectRules[EffectRules["NowAdd2Hour"] = 4] = "NowAdd2Hour";
})(EffectRules || (EffectRules = {}));
export var EffectRulesValueMap = (_k = {},
    _k[EffectRules.Now] = '立即生效',
    _k[EffectRules.Hour] = '整点生效',
    _k[EffectRules.Tomorrow] = '次日凌晨',
    _k[EffectRules.NowAdd1Hour] = '立即生效+1小时',
    _k[EffectRules.NowAdd2Hour] = '立即生效+2小时',
    _k);
// 参照人保的企业单位关系
export var EnterpriseNature = {
    "100": "机关、团体",
    "110": "国家机关",
    "118": "军队(武警)",
    "119": "使领馆",
    "120": "党政机关",
    "130": "社会团体",
    "140": "基层群众自治组织",
    "200": "事业单位",
    "210": "卫生事业",
    "220": "体育事业",
    "230": "社会事业",
    "240": "教育事业",
    "250": "文化艺术业",
    "260": "广播电影电视业",
    "270": "科学研究业",
    "280": "综合技术服务业",
    "300": "企业单位",
    "310": "国有",
    "320": "集体",
    "330": "个体",
    "340": "私营",
    "350": "三资",
    "351": "中外合资",
    "352": "中外合作",
    "353": "外商独资",
    "360": "混合所有制",
    "370": "合作",
    "380": "合伙",
    "390": "股份制企业",
    "900": "其他",
    "400": "民营"
};
